export const CONSENT_FLAGS = {
  amplar: 'amplar_consent',
  myhealth: 'myhealth_consent',
} as const;

export const MOBILE_VERIFIED_FLAG = 'mobile_verified';

export const STEP_IDS = {
  terms: 'terms',
  marketing: 'marketing',
  mobile: 'mobile',
  verify: 'verify',
  personalInformation: 'personalInformation',
  personalInfoReview: 'personalInfoReview',
  complete: 'complete',
} as const;

export type StepId = (typeof STEP_IDS)[keyof typeof STEP_IDS];

export const STEP_STRING_IDS = {
  terms: {
    heading: 'STR_ONBOARDING_ACCOUNT_SETUP_TERMS_HEADING',
    body: 'STR_ONBOARDING_ACCOUNT_SETUP_TERMS_SUMMARY',
    primaryButtonLabel: 'STR_ONBOARDING_ACCOUNT_SETUP_TERMS_PRIMARY_BUTTON',
  },
  marketing: {
    heading: 'STR_ONBOARDING_ACCOUNT_SETUP_MARKETING_HEADING',
    body: 'STR_ONBOARDING_ACCOUNT_SETUP_MARKETING_BODY',
    primaryButtonLabel: 'STR_ONBOARDING_ACCOUNT_SETUP_MARKETING_PRIMARY_BUTTON',
    secondaryButtonLabel:
      'STR_ONBOARDING_ACCOUNT_SETUP_MARKETING_SECONDARY_BUTTON',
  },
  mobile: {
    heading: 'STR_ONBOARDING_ACCOUNT_SETUP_MOBILE_HEADING',
    primaryButtonLabel: 'STR_ONBOARDING_ACCOUNT_SETUP_MOBILE_PRIMARY_BUTTON',
    secondaryButtonLabel:
      'STR_ONBOARDING_ACCOUNT_SETUP_MOBILE_SECONDARY_BUTTON',
  },
  verify: {
    heading: 'STR_ONBOARDING_ACCOUNT_SETUP_VERIFY_HEADING',
    subHeading: 'STR_ONBOARDING_ACCOUNT_SETUP_VERIFY_SUBHEADING',
    primaryButtonLabel: 'STR_ONBOARDING_ACCOUNT_SETUP_VERIFY_PRIMARY_BUTTON',
    secondaryButtonLabel:
      'STR_ONBOARDING_ACCOUNT_SETUP_VERIFY_SECONDARY_BUTTON',
  },
  personalInformation: {
    heading: 'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_HEADING',
    subHeading: 'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_SUBHEADING',
    primaryButtonLabel:
      'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_PRIMARY_BUTTON',
  },
  personalInfoReview: {
    heading: 'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_REVIEW_HEADING',
    subHeading: 'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_REVIEW_SUBHEADING',
    primaryButtonLabel:
      'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_REVIEW_PRIMARY_BUTTON',
    secondaryButtonLabel:
      'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_REVIEW_SECONDARY_BUTTON',
  },
  complete: {
    heading: 'STR_ONBOARDING_ACCOUNT_SETUP_COMPLETE_HEADING',
    subHeading: 'STR_ONBOARDING_ACCOUNT_SETUP_COMPLETE_SUBHEADING',
    primaryButtonLabel: 'STR_ONBOARDING_ACCOUNT_SETUP_COMPLETE_PRIMARY_BUTTON',
    secondaryButtonLabel:
      'STR_ONBOARDING_ACCOUNT_SETUP_COMPLETE_SECONDARY_BUTTON',
    body: 'STR_ONBOARDING_ACCOUNT_SETUP_COMPLETE_BODY',
  },
} as const;
